import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class FacilityTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'egipRegistryNumber',
        title: 'Реестровый номер ИАС Спорт',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'balanceHolder',
        title: 'Балансодержатель',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'name',
        title: 'Наименование объекта',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'facilityAddress',
        title: 'Адрес',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        disabled: false,
        default: false,
      },
    ];
  }


}
